// File: src/components/FeedbackWidget.jsx
import React, { useState, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// --- CẤU HÌNH CLOUDINARY ---
const CLOUD_NAME = "dcadn2syh"; 
const UPLOAD_PRESET = "skillmatch_feedback";   

// --- DỮ LIỆU GÓI DỊCH VỤ (ỨNG VIÊN) ---
const candidatePromotions = [
    {
        id: 'student_plus',
        badge: 'PLUS',
        target: 'Sinh viên',
        title: "Gói Student Plus",
        price: "29.000đ",
        period: "/tháng",
        desc: "Mở khóa lộ trình học tập & 50 mẫu CV.",
        icon: "school", 
        gradient: "linear-gradient(135deg, #06B6D4 0%, #0891B2 100%)", 
        link: "/candidate/upgrade-account"
    },
    {
        id: 'pro',
        badge: 'PRO',
        target: 'Người tìm việc',
        title: "Gói PRO",
        price: "49.000đ",
        period: "/tháng",
        desc: "Đẩy Top hồ sơ & Xem mức lương thị trường.",
        icon: "rocket_launch", 
        gradient: "linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)", 
        link: "/candidate/upgrade-account"
    },
    {
        id: 'premium',
        badge: 'VIP',
        target: 'Người đi làm',
        title: "Gói PREMIUM",
        price: "99.000đ",
        period: "/tháng",
        desc: "AI Cố vấn sự nghiệp & Gợi ý khóa học.",
        icon: "diamond",
        gradient: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)", 
        link: "/candidate/upgrade-account"
    }
];

// --- DỮ LIỆU GÓI DỊCH VỤ (DOANH NGHIỆP) ---
const businessPromotions = [
    {
        id: 'business_free',
        badge: 'FREE',
        target: 'Start-up',
        title: "Gói FREE",
        price: "0đ",
        period: "/vĩnh viễn",
        desc: "Đăng 1 tin, tạo 1 bài Test, xem 5 hồ sơ ứng viên.",
        icon: "storefront",
        gradient: "linear-gradient(135deg, #9CA3AF 0%, #6B7280 100%)", 
        link: "/business/upgrade-account"
    },
    {
        id: 'business_pro',
        badge: 'HOT',
        target: 'Doanh nghiệp',
        title: "Gói PRO",
        price: "1.500k",
        period: "/tháng",
        desc: "Đăng 10 tin, 10 bài Test AI, xem 100 hồ sơ ứng viên.",
        icon: "rocket_launch",
        gradient: "linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)", 
        link: "/business/upgrade-account"
    },
    {
        id: 'business_premium',
        badge: 'VIP',
        target: 'Tập đoàn',
        title: "Gói PREMIUM",
        price: "8.000k",
        period: "/6 tháng",
        desc: "Không giới hạn tin đăng, Test & AI chống gian lận.",
        icon: "diamond",
        gradient: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)", 
        link: "/business/upgrade-account"
    }
];

// --- COMPONENT: CAROUSEL QUẢNG CÁO ---
const PromotionCarousel = ({ isVisible, setIsVisible, activePromotions }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        if (!isVisible || !activePromotions || activePromotions.length === 0) return;
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % activePromotions.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [isVisible, activePromotions]);

    if (!activePromotions || activePromotions.length === 0) return null;
    const promo = activePromotions[currentSlide];
    if (!promo) return null;

    if (isVisible) {
        return (
            <div 
                className="promo-card"
                onClick={() => navigate(promo.link)}
                style={{
                    width: '340px', backgroundColor: 'white', borderRadius: '16px',
                    boxShadow: '0 8px 30px rgba(0,0,0,0.15)', marginBottom: '12px',
                    position: 'relative', overflow: 'hidden',
                    animation: 'fadeInUp 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
                    border: '1px solid white', cursor: 'pointer',
                    display: 'flex', height: '110px'
                }}
            >
                <button 
                    onClick={(e) => { e.stopPropagation(); setIsVisible(false); }}
                    style={{
                        position: 'absolute', top: '8px', right: '8px',
                        border: 'none', background: '#F3F4F6', borderRadius: '50%', 
                        width: '24px', height: '24px', cursor: 'pointer', color: '#6B7280', 
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        zIndex: 10, transition: 'background 0.2s'
                    }}
                    title="Ẩn quảng cáo"
                >
                    <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>close</span>
                </button>

                <div style={{
                    width: '110px', background: promo.gradient, display: 'flex', flexDirection: 'column',
                    alignItems: 'center', justifyContent: 'center', color: 'white', flexShrink: 0, position: 'relative'
                }}>
                    <span className="material-symbols-outlined" style={{ fontSize: '42px', marginBottom: '4px', filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))' }}>
                        {promo.icon}
                    </span>
                    <span style={{ fontSize: '11px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px' }}>
                        {promo.badge}
                    </span>
                    <div style={{ position: 'absolute', width: '150%', height: '100%', background: 'rgba(255,255,255,0.1)', transform: 'skewX(-20deg)', left: '-100%' }}></div>
                </div>

                <div style={{ padding: '12px 16px 12px 14px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <div style={{ fontSize: '10px', color: '#6B7280', fontWeight: '700', textTransform: 'uppercase', marginBottom: '2px', letterSpacing: '0.5px' }}>
                        {promo.target}
                    </div>
                    <h4 style={{ margin: 0, fontSize: '15px', fontWeight: 'bold', color: '#111827', lineHeight: '1.2' }}>
                        {promo.title}
                    </h4>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '2px', margin: '4px 0' }}>
                        <span style={{ fontSize: '18px', fontWeight: '800', color: '#EF4444' }}>{promo.price}</span>
                        <span style={{ fontSize: '11px', color: '#6B7280' }}>{promo.period}</span>
                    </div>
                    <p style={{ margin: 0, fontSize: '11px', color: '#4B5563', lineHeight: '1.3', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: '2', WebkitBoxOrient: 'vertical' }}>
                        {promo.desc}
                    </p>
                </div>

                <div style={{ position: 'absolute', bottom: '8px', right: '50%', transform: 'translateX(50%)', display: 'flex', gap: '4px' }}>
                    {activePromotions.map((_, index) => (
                        <div 
                            key={index}
                            style={{
                                width: '4px', height: '4px', borderRadius: '50%',
                                backgroundColor: currentSlide === index ? '#2563EB' : '#E5E7EB',
                                transition: 'all 0.3s'
                            }}
                        />
                    ))}
                </div>
                <style>{`
                    @keyframes fadeInUp { from { opacity: 0; transform: translateY(20px) scale(0.95); } to { opacity: 1; transform: translateY(0) scale(1); } }
                    .promo-card:hover { transform: translateY(-3px); box-shadow: 0 15px 40px rgba(0,0,0,0.15) !important; transition: transform 0.2s ease; }
                `}</style>
            </div>
        );
    }

    return (
        <button
            onClick={() => setIsVisible(true)}
            className="widget-btn-icon"
            style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                backgroundColor: 'white', color: '#F59E0B', 
                padding: '0', width: '48px', height: '48px', borderRadius: '50%',
                boxShadow: '0 4px 15px rgba(0,0,0,0.1)', border: '2px solid #FFF7ED', cursor: 'pointer',
                transition: 'all 0.3s ease', marginBottom: '8px', animation: 'popIn 0.3s ease'
            }}
            title="Xem ưu đãi"
        >
            <span className="material-symbols-outlined" style={{ fontSize: '24px' }}>local_fire_department</span>
            <style>{`@keyframes popIn { from { transform: scale(0); } to { transform: scale(1); } }`}</style>
        </button>
    );
};

const topics = ["Báo lỗi", "Góp ý tính năng", "Giao diện", "Khác"];

const Toast = ({ message, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(onClose, 3000); 
        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div style={{
            position: 'fixed', bottom: '24px', left: '24px', zIndex: 10000,
            backgroundColor: '#374151', color: 'white', padding: '12px 20px', 
            borderRadius: '8px', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
            display: 'flex', alignItems: 'center', gap: '10px',
            animation: 'slideInLeft 0.3s ease-out'
        }}>
            <span className="material-symbols-outlined" style={{ color: '#34D399' }}>check_circle</span>
            {message}
        </div>
    );
};

const ratings = [
    { score: 1, icon: "😡", label: "Rất tệ" },
    { score: 2, icon: "😟", label: "Tệ" },
    { score: 3, icon: "😐", label: "Bình thường" },
    { score: 4, icon: "🙂", label: "Tốt" },
    { score: 5, icon: "😍", label: "Tuyệt vời" },
];

export default function FeedbackWidget() {
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [isPromoVisible, setIsPromoVisible] = useState(true);

    const [topic, setTopic] = useState("Góp ý tính năng");
    const [message, setMessage] = useState("");
    const [rating, setRating] = useState(5);
    const [selectedFile, setSelectedFile] = useState(null); 
    const [previewUrl, setPreviewUrl] = useState(null);     
    const [loading, setLoading] = useState(false);
    const [toastMsg, setToastMsg] = useState(null);
    
    const fileInputRef = useRef(null);

    const token = localStorage.getItem('skillmatch_token');
    
    // 🚫 Ẩn widget ở trang thi, admin hoặc chưa login
    if (!token || location.pathname.includes('/candidate/exam/') || location.pathname.includes('/admin') || location.pathname.includes('/business/tests/new') || location.pathname.includes('/business/tests/edit/')){
        return null;
    }

    // ✅ ĐÃ FIX LỖI NHẬN DIỆN ROLE SIÊU AN TOÀN
    let userRole = 'candidate'; 
    const currentPath = location.pathname.toLowerCase();

    // 1. Kiểm tra trực tiếp qua đường dẫn URL (Không bao giờ sai)
    if (currentPath.includes('/business') || currentPath.includes('/employer')) {
        userRole = 'business';
    } 
    // 2. Dự phòng giải mã Token (Có hàm an toàn chống lỗi Unicode tiếng Việt)
    else if (token) {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            
            const payloadObj = JSON.parse(jsonPayload);
            const extractedRole = payloadObj?.role || (payloadObj?.user && payloadObj.user.role) || '';
            
            if (extractedRole.toLowerCase() === 'business') {
                userRole = 'business';
            }
        } catch (err) {
            console.warn("Lỗi Decode Token trong Widget (Bỏ qua):", err);
        }
    }

    // ✅ Map list quảng cáo đúng theo Role
    const activePromotions = userRole === 'business' ? businessPromotions : candidatePromotions;

    const handleImageSelect = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (!file.type.startsWith('image/')) { alert("Vui lòng chỉ chọn file ảnh."); return; }
        if (file.size > 3 * 1024 * 1024) { alert("Ảnh quá lớn! Vui lòng chọn ảnh dưới 3MB."); return; }
        setSelectedFile(file);
        setPreviewUrl(URL.createObjectURL(file));
    };

    const removeImage = () => {
        setSelectedFile(null);
        setPreviewUrl(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const uploadToCloudinary = async (file) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", UPLOAD_PRESET);
        try {
            const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, { method: "POST", body: formData });
            const data = await res.json();
            return data.secure_url;
        } catch (error) { throw new Error("Lỗi tải ảnh lên Cloud"); }
    };

    const handleSubmit = async () => {
        if (!message.trim()) return alert("Vui lòng nhập nội dung góp ý");
        setLoading(true);
        try {
            let imageUrl = null;
            if (selectedFile) imageUrl = await uploadToCloudinary(selectedFile);

            const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';
            
            await fetch(`${API_URL}/api/feedback`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
                body: JSON.stringify({ topic, message, rating, image: imageUrl })
            });
            
            setToastMsg("Cảm ơn bạn đã đóng góp ý kiến!");
            setIsOpen(false);
            setMessage("");
            setRating(5);
            removeImage();
        } catch (error) { alert("Lỗi: " + error.message); } finally { setLoading(false); }
    };

    return (
        <>
            <div 
                style={{ 
                    position: 'fixed', bottom: '100px', right: '24px', zIndex: 9998, 
                    display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'end', pointerEvents: 'none'
                }}
            >
                <div style={{ pointerEvents: 'auto' }}>
                    <PromotionCarousel 
                        isVisible={isPromoVisible} 
                        setIsVisible={setIsPromoVisible} 
                        activePromotions={activePromotions}
                    />
                </div>

                <div 
                    style={{ pointerEvents: 'auto', display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'end' }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <button
                        onClick={() => setIsOpen(true)}
                        className="widget-btn"
                        style={{
                            display: 'flex', alignItems: 'center', gap: '8px',
                            backgroundColor: '#2563EB', color: 'white',
                            padding: '10px 16px', borderRadius: '30px',
                            boxShadow: '0 4px 15px rgba(37, 99, 235, 0.3)',
                            border: 'none', cursor: 'pointer', fontWeight: '600',
                            transition: 'all 0.3s ease',
                            width: isHovered ? '110px' : '50px',
                            height: '50px', overflow: 'hidden', whiteSpace: 'nowrap',
                            justifyContent: isHovered ? 'flex-start' : 'center'
                        }}
                    >
                        <span className="material-symbols-outlined">reviews</span>
                        {isHovered && <span>Góp ý</span>}
                    </button>

                    <button
                        onClick={() => window.open('https://zalo.me/0394742067', '_blank')} 
                        className="widget-btn"
                        style={{
                            display: 'flex', alignItems: 'center', gap: '8px',
                            backgroundColor: 'white', color: '#2563EB',
                            padding: '10px 16px', borderRadius: '30px',
                            boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                            border: 'none', cursor: 'pointer', fontWeight: '600',
                            transition: 'all 0.3s ease',
                            width: isHovered ? '110px' : '50px',
                            height: '50px', overflow: 'hidden', whiteSpace: 'nowrap',
                            justifyContent: isHovered ? 'flex-start' : 'center'
                        }}
                    >
                        <span className="material-symbols-outlined">support_agent</span>
                        {isHovered && <span>Hỗ trợ</span>}
                    </button>
                </div>
            </div>

            {isOpen && (
                <div style={{ position: 'fixed', inset: 0, zIndex: 9999, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ backgroundColor: 'white', borderRadius: '16px', width: '90%', maxWidth: '500px', padding: '24px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)', animation: 'scaleUp 0.2s ease-out' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                            <h3 style={{ fontSize: '20px', fontWeight: 'bold', color: '#111827' }}>Góp ý sản phẩm</h3>
                            <button onClick={() => setIsOpen(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '24px', color: '#9CA3AF' }}>&times;</button>
                        </div>

                        <div style={{ marginBottom: '20px' }}>
                            <p style={{ fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '8px' }}>Chủ đề *</p>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                {topics.map(t => (
                                    <button key={t} onClick={() => setTopic(t)} style={{ padding: '6px 12px', borderRadius: '20px', fontSize: '13px', border: topic === t ? '1px solid #2563EB' : '1px solid #E5E7EB', backgroundColor: topic === t ? '#EFF6FF' : 'white', color: topic === t ? '#2563EB' : '#374151', cursor: 'pointer', transition: 'all 0.2s', fontWeight: '500' }}>{t}</button>
                                ))}
                            </div>
                        </div>

                        <div style={{ marginBottom: '20px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                                <p style={{ fontSize: '14px', fontWeight: '600', color: '#374151', margin: 0 }}>Chi tiết *</p>
                                <button onClick={() => fileInputRef.current.click()} style={{ border: 'none', background: 'none', color: '#2563EB', fontSize: '13px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <span className="material-symbols-outlined" style={{fontSize: '18px'}}>add_photo_alternate</span> Đính kèm ảnh
                                </button>
                                <input type="file" ref={fileInputRef} onChange={handleImageSelect} accept="image/*" style={{ display: 'none' }} />
                            </div>
                            <textarea value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Mô tả lỗi hoặc góp ý của bạn..." style={{ width: '100%', height: '100px', padding: '12px', borderRadius: '8px', border: '1px solid #D1D5DB', fontSize: '14px', outline: 'none', resize: 'none', backgroundColor: 'white', color: '#111827' }} />
                            {previewUrl && (
                                <div style={{ marginTop: '10px', position: 'relative', width: 'fit-content' }}>
                                    <img src={previewUrl} alt="Preview" style={{ height: '80px', borderRadius: '8px', border: '1px solid #E5E7EB', objectFit: 'cover' }} />
                                    <button onClick={removeImage} style={{ position: 'absolute', top: '-8px', right: '-8px', background: '#EF4444', color: 'white', border: 'none', borderRadius: '50%', width: '20px', height: '20px', cursor: 'pointer', fontSize: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>&times;</button>
                                </div>
                            )}
                        </div>

                        <div style={{ marginBottom: '24px', textAlign: 'center' }}>
                            <p style={{ fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '12px' }}>Đánh giá trải nghiệm</p>
                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 20px' }}>
                                {ratings.map(r => (
                                    <div key={r.score} onClick={() => setRating(r.score)} style={{ cursor: 'pointer', opacity: rating === r.score ? 1 : 0.4, transform: rating === r.score ? 'scale(1.2)' : 'scale(1)', transition: 'all 0.2s', filter: rating === r.score ? 'none' : 'grayscale(100%)' }}>
                                        <div style={{ fontSize: '32px' }}>{r.icon}</div>
                                        <div style={{ fontSize: '10px', marginTop: '4px', color: '#4B5563' }}>{r.label}</div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: '12px' }}>
                            <button onClick={() => setIsOpen(false)} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1px solid #D1D5DB', backgroundColor: 'white', color: '#374151', fontWeight: '600', cursor: 'pointer' }}>Hủy</button>
                            <button onClick={handleSubmit} disabled={loading} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: 'none', backgroundColor: '#10B981', color: 'white', fontWeight: '600', cursor: 'pointer', opacity: loading ? 0.7 : 1, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
                                {loading ? (<><span className="material-symbols-outlined text-sm animate-spin">sync</span> Đang gửi...</>) : 'Gửi phản hồi'}
                            </button>
                        </div>
                    </div>
                    <style>{`
                        @keyframes scaleUp { from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1; } }
                        .widget-btn:hover { transform: translateY(-2px); }
                    `}</style>
                </div>
            )}
            {toastMsg && <Toast message={toastMsg} onClose={() => setToastMsg(null)} />}
        </>
    );
}